export const API_GET_ALL_CLIENT = "/cliente/";
export const API_GET_SEARCH_CLIENTS = "/cliente/";
export const API_PUT_UPDATE_CLIENTS = "/cliente/actualizar";
export const API_POST_SAVE_CLIENTS = "/cliente/registrar";